__turbopack_context__.v({
  "accordionSlideOverwrite": "commonStyles-module-scss-module__Q6924W__accordionSlideOverwrite",
  "articleParagraph": "commonStyles-module-scss-module__Q6924W__articleParagraph",
  "blockQuoteText": "commonStyles-module-scss-module__Q6924W__blockQuoteText",
  "container": "commonStyles-module-scss-module__Q6924W__container",
  "fadeIn": "commonStyles-module-scss-module__Q6924W__fadeIn",
  "fadeOut": "commonStyles-module-scss-module__Q6924W__fadeOut",
  "scaleIn": "commonStyles-module-scss-module__Q6924W__scaleIn",
  "scaleOut": "commonStyles-module-scss-module__Q6924W__scaleOut",
  "scrollContainer": "commonStyles-module-scss-module__Q6924W__scrollContainer",
  "sectionBody": "commonStyles-module-scss-module__Q6924W__sectionBody",
  "sectionBodySmall": "commonStyles-module-scss-module__Q6924W__sectionBodySmall",
  "sectionColor": "commonStyles-module-scss-module__Q6924W__sectionColor",
  "sectionContent": "commonStyles-module-scss-module__Q6924W__sectionContent",
  "sectionHeading": "commonStyles-module-scss-module__Q6924W__sectionHeading",
  "sectionLink": "commonStyles-module-scss-module__Q6924W__sectionLink",
  "sectionParagraph": "commonStyles-module-scss-module__Q6924W__sectionParagraph",
  "sectionPrice": "commonStyles-module-scss-module__Q6924W__sectionPrice",
  "sectionSubheadingH2": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH2",
  "sectionSubheadingH3": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH3",
  "sectionSubheadingH4": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH4",
  "sectionSubheadingH5": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH5",
  "sectionSubheadingH6": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH6",
  "sectionSubheadingH7": "commonStyles-module-scss-module__Q6924W__sectionSubheadingH7",
  "textOverflowEllipsis": "commonStyles-module-scss-module__Q6924W__textOverflowEllipsis",
  "zoomIn": "commonStyles-module-scss-module__Q6924W__zoomIn",
  "zoomOut": "commonStyles-module-scss-module__Q6924W__zoomOut",
});
